import React from 'react';
import { Routes } from 'react-router-dom';
import {
  loginAndAccessRoutes,
  globalSettingsRoutes,
  darRoutes,
  dataCollectionRoutes,
  dataViewRoutes,
  homeAndAnalyticsRoutes,
  usersRobotsRoutes,
  employeeLeaveRoutes,
  paymentRoutes,
  clientDashboardRoutes,
  adminUserDashboardRoutes,
} from './groups';

const allRoutes = [
  ...loginAndAccessRoutes,
  ...globalSettingsRoutes,
  ...darRoutes,
  ...dataCollectionRoutes,
  ...dataViewRoutes,
  ...homeAndAnalyticsRoutes,
  ...usersRobotsRoutes,
  ...employeeLeaveRoutes,
  ...paymentRoutes,
  ...clientDashboardRoutes,
  ...adminUserDashboardRoutes,
];

const AfterLoginRoutes = () => <Routes>{allRoutes}</Routes>;

export default AfterLoginRoutes;
